import { useTranslation } from 'react-i18next';

const AVATARS = {
  smile: '😀', cool: '😎', star: '🤩', party: '🥳', cat: '😺', fox: '🦊',
  penguin: '🐧', sparkle: '🌟', robot: '🤖', alien: '👽', unicorn: '🦄',
  bear: '🐻', dog: '🐶', octopus: '🐙', butterfly: '🦋', dragon: '🐉',
  astronaut: '🚀', wizard: '🧙',
};

function formatTime(ms) {
  if (!ms) return '';
  const d = new Date(ms);
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `${hh}:${mm}`;
}

const styles = {
  card: {
    background: '#1E293B', borderRadius: 10, padding: '1rem 1.25rem',
    boxShadow: '0 2px 8px rgba(0,0,0,0.25)', border: '1px solid #334155',
    display: 'flex', alignItems: 'center', gap: '1rem',
  },
  avatar: {
    width: 40, height: 40, borderRadius: '50%', background: 'rgba(6,182,212,0.12)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: '1.3rem', flexShrink: 0,
  },
  ticketId: { fontWeight: 700, fontSize: '0.9rem', color: '#F8FAFC' },
  meta: { fontSize: '0.75rem', color: '#94A3B8' },
  wait: { color: '#94A3B8', fontSize: '0.8rem' },
  actions: { display: 'flex', gap: 8 },
  btnSkip: {
    padding: '0.4rem 0.75rem', borderRadius: 6, border: '1.5px solid #F59E0B',
    background: 'transparent', color: '#B45309', fontWeight: 600, cursor: 'pointer', fontSize: '0.8rem',
  },
  btnFinish: {
    padding: '0.4rem 0.75rem', borderRadius: 6, border: 'none',
    background: '#10B981', color: '#fff', fontWeight: 600, cursor: 'pointer', fontSize: '0.8rem',
  },
};

export function TicketCard({ entry, onSkip, onFinish }) {
  const { t } = useTranslation();
  const waitMin = Math.ceil(entry.estimatedWaitSeconds / 60);
  const emoji = AVATARS[entry.avatarId] || '😀';
  const joinedTime = formatTime(entry.joinedAtMs);

  return (
    <div style={styles.card}>
      <div style={styles.avatar}>{emoji}</div>
      <div style={{ flex: 1 }}>
        <div style={styles.ticketId}>#{entry.ticketNumber || entry.position} &middot; {entry.firstName || t('ticketCard.guest')}</div>
        <div style={styles.meta}>
          {t('ticketCard.joined')} {joinedTime} &middot; ~{waitMin} {t('ticketCard.minWait')}
        </div>
      </div>
      <div style={styles.actions}>
        <button style={styles.btnSkip} onClick={() => onSkip(entry.ticketUuid)}>{t('ticketCard.skipBtn')}</button>
        <button style={styles.btnFinish} onClick={() => onFinish(entry.ticketUuid)}>{t('ticketCard.doneBtn')}</button>
      </div>
    </div>
  );
}
